import { themeAtom } from "../../../shared/atoms";
import { ADMIN_PATHS } from "../../models/admin.models";
import { useAtomValue } from "jotai";
import { NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const AdminVoyagePnlViewTabs = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="border-b border-[#E6ECEA] bg-white px-8 pt-6" data-test="admin-voyage-pnl-view-tabs">
      <nav aria-label="Voyage PnL admin views" className="flex flex-wrap gap-8">
        <NavLink
          to={ADMIN_PATHS.voyagePnl}
          end
          className={({ isActive }) =>
            twMerge(
              theme.home.tailwind.textDefault,
              "border-b-2 pb-3 text-sm font-semibold transition-colors",
              isActive
                ? "border-[#118A7E] text-[#0B7C71]"
                : "border-transparent text-[#556270] hover:border-[#BEE4DD] hover:text-[#0B7C71]",
            )
          }
        >
          Senior VO Users
        </NavLink>
      </nav>
    </div>
  );
};

export default AdminVoyagePnlViewTabs;
